import { render, staticRenderFns } from "./orderBox.vue?vue&type=template&id=2ee4ff34&scoped=true"
import script from "./orderBox.vue?vue&type=script&lang=js"
export * from "./orderBox.vue?vue&type=script&lang=js"
import style0 from "./orderBox.vue?vue&type=style&index=0&id=2ee4ff34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee4ff34",
  null
  
)

export default component.exports